import React, { useState, useEffect, useRef } from "react";
import {
  Text,
  View,
  TextInput,
  StyleSheet,
  Dimensions,
  Image,
  FlatList,
  ActivityIndicator,
  Animated,
  ScrollView,
} from "react-native";
import { colors } from "../Styles/colors.js";
import { Hoverable, Pressable } from "react-native-web-hover";
import { Feather, Ionicons } from "@expo/vector-icons";
import { db } from "../firebase.js";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
} from "firebase/firestore";
import NewsItems from "../Components/NewsItems";
import { CategoriesData } from "../Data/CategoriesData";
import { SearchSourceData } from "../Data/SearchSourceData";
import SearchHistoryItem from "../Components/SearchHistoryItem";
import SearchSourceItem from "../Components/SearchSourceItem";
import ReadArticleItem from "../Components/ReadArticleItem";
import { Input, Overlay } from "react-native-elements";
import * as WebBrowser from "expo-web-browser";
import {
  reduxSearchHistory,
  reduxRead,
  reduxBookmarks,
} from "../redux/actions";
import CategoriesItem from "../Components/CategoriesItem.js";
import { useDispatch, useSelector } from "react-redux";
import { deviceType } from "react-device-detect";
import * as Animatable from "react-native-animatable";
import MobileNewsItems from "../Components/MobileNewsItems.js";
import {
  useFonts,
  Inter_400Regular,
  Inter_500Medium,
  Inter_600SemiBold,
  Inter_700Bold,
  Inter_800ExtraBold,
  Inter_900Black,
} from "@expo-google-fonts/Inter";
import { TouchableOpacity } from "react-native-gesture-handler";

export default function News({ navigation }) {
  let [fontsLoaded] = useFonts({
    Inter_400Regular,
    Inter_500Medium,
    Inter_600SemiBold,
    Inter_700Bold,
    Inter_800ExtraBold,
    Inter_900Black,
  });

  const [search, setSearch] = useState("");
  const [sourceSearch, setSourceSearch] = useState("");
  const [sourceSearchData, setSourceSearchData] = useState([]);
  const [newsStories, setNewsStories] = useState([]);
  const [searchArticleData, setSearchArticleData] = useState([]);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [selectedStoryAuthor, setSelectedStoryAuthor] = useState("");
  const [selectedStoryTitle, setSelectedStoryTitle] = useState("");
  const [selectedStoryAuthorIcon, setSelectedStoryAuthorIcon] = useState("");
  const [selectedStoryArticleCategory, setSelectedStoryArticleCategory] =
    useState("");
  const [selectedStoryImage, setSelectedStoryImage] = useState("");
  const [selectedStoryArticleStart, setSelectedStoryArticleStart] =
    useState("");
  const [selectedStoryArticleContent, setSelectedStoryArticleContent] =
    useState("");
  const [selectedStoryArticleLink, setSelectedStoryArticleLink] = useState("");
  const [pressedCategories, setPressedCategories] = useState(false);
  const [pressedSources, setPressedSources] = useState(false);
  const [triggerSavedSearchRefresh, setTriggerSavedSearchRefresh] =
    useState(false);
  const [triggerReadArticles, setTriggerReadArticles] = useState(false);
  const [bookmarked, setBookmarked] = useState([]);
  const [showBookmarks, setShowBookmarks] = useState(false);
  const [bookmarkButtonHovering, setBookmarkButtonHovering] = useState(false);
  const [scrollRefresh, setScrollRefresh] = useState(false);
  const [fetchingStories, setFetchingStories] = useState(false);
  const [tabletShowSidebar, setTabletShowSidebar] = useState(false);
  const [mobileShowSidebar, setMobileShowSidebar] = useState(false);
  const [mobileShowSearch, setMobileShowSearch] = useState(false);
  const [hidePromo, setHidePromo] = useState(false); //set to false
  const [lastVisibleData, setLastVisibleData] = useState("");
  const width = Dimensions.get("window").width;
  const height = Dimensions.get("window").height;
  const browserSourceColumns =
    width > 1500 ? 6 : width > 1240 ? 5 : width > 980 ? 4 : 3;
  const browserSourceTileWidth = Math.max(
    150,
    Math.min(220, (width - 120) / browserSourceColumns),
  );
  const browserSourceTileHeight = Math.max(
    110,
    Math.min(160, browserSourceTileWidth * 0.66),
  );

  //-------------------------------------------//
  //                   Redux                   //
  //-------------------------------------------//
  //Define dispatch for redux
  const dispatch = useDispatch();

  //Get the saved searches from redux
  const currentSavedSearches = useSelector(
    (state) => state.searches.searchHistory,
  );

  //Get the read articles from redux
  const currentReadArticles = useSelector((state) => state.read.read);

  //Get the selected news categories from redux
  const currentCategoriesSelection = useSelector(
    (state) => state.category.categorySelections,
  );

  //-------------------------------------------//
  //                 Bookmarks                 //
  //-------------------------------------------//
  //Consolidate all of the article items to pass into redux
  const bookmarkArticle = {
    ArticleAuthorIcon: selectedStoryAuthorIcon,
    ArticleAuthor: selectedStoryAuthor,
    ArticleTitle: selectedStoryTitle,
    ArticleCategory: selectedStoryArticleCategory,
    ArticleStart: selectedStoryArticleStart,
    ArticleContent: selectedStoryArticleContent,
    ArticleImage: selectedStoryImage,
    ArticleLink: selectedStoryArticleLink,
  };

  //Function when bookmark is pressed
  const pressBookmark = (link, articleContents) => {
    //Create list for all the bookmarks
    console.log("Link Pressed: ", link);
    const allBookmarks = [];
    const currentBookmarksListOrNot =
      currentBookmarks != null ? currentBookmarks : [];
    for (var i = 0; i < currentBookmarksListOrNot.length; i++) {
      allBookmarks.push(currentBookmarks[i]);
    }

    //If not bookmarked, push the bookmark to state (front of list so it appears first)
    !bookmarked.includes(link) && allBookmarks.unshift(articleContents);

    //If it is bookmarked, remove article from state
    for (var i = 0; i < allBookmarks.length; i++) {
      if (allBookmarks[i].ArticleLink == link) {
        bookmarked.includes(link) && allBookmarks.splice(i, 1);
        break;
      }
    }
    dispatch(reduxBookmarks(allBookmarks));

    //set state of all the bookmarked articles for the bookmark icon
    const allBookmarkedArticles = [];
    for (var i = 0; i < allBookmarks.length; i++) {
      allBookmarkedArticles.push(allBookmarks[i].ArticleLink);
    }
    setBookmarked(allBookmarkedArticles);
  };

  //Get the bookmarked stories from redux
  const currentBookmarks = useSelector(
    (state) => state.bookmark.bookmarkArticle,
  );

  //Set initial state of all the bookmarked articles for the bookmark icon
  useEffect(() => {
    const allBookmarkedArticles = [];
    try {
      for (var i = 0; i < currentBookmarks?.length; i++) {
        allBookmarkedArticles.push(currentBookmarks[i].ArticleLink);
      }

      setBookmarked(allBookmarkedArticles);

      //If all the stories become unbookmarked, set the 'show bookmark' state to false
      !currentBookmarks?.length > 0 && setShowBookmarks(false);
    } catch {
      setBookmarked(allBookmarkedArticles);

      //If all the stories become unbookmarked, set the 'show bookmark' state to false
      !currentBookmarks?.length > 0 && setShowBookmarks(false);
    }
  }, [currentBookmarks]);

  //-------------------------------------------//
  //                Animations                 //
  //-------------------------------------------//
  //These are used in the scrolling animation
  const scrollY = new Animated.Value(0);
  const scale = scrollY.interpolate({
    inputRange: [-50, 0],
    outputRange: [1.05, 1],
    extrapolate: "clamp",
  });
  const opacity = scrollY.interpolate({
    inputRange: [0, 25],
    outputRange: [1, 0],
  });

  //-------------------------------------------//
  //                  Search                   //
  //-------------------------------------------//
  //Delete search history
  const clearRecentSearch = () => {
    dispatch(reduxSearchHistory([]));
    setTriggerSavedSearchRefresh(!triggerSavedSearchRefresh);
  };

  //Save the searches when search editing finishes
  const saveSearches = (search) => {
    const savedSearchHistory =
      currentSavedSearches?.length > 0 ? currentSavedSearches : [];

    search != "" && savedSearchHistory.unshift(search);
    const removeDupSearches = [...new Set(savedSearchHistory)];
    dispatch(reduxSearchHistory(removeDupSearches.slice(0, 3)));
    setTriggerSavedSearchRefresh(!triggerSavedSearchRefresh);
  };

  //Function to handle source search
  const updateSourceSearch = (text) => {
    const sources = SearchSourceData;
    const filteredData = sources.filter(function (item) {
      //Applying filter for source name in search bar
      const itemData = item.ArticleAuthor.toUpperCase();
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    });

    setSourceSearch(text);
    text == ""
      ? setSourceSearchData(SearchSourceData)
      : setSourceSearchData(filteredData);
  };

  //Function to handle news article searches
  const updateSearch = (text) => {
    setTabletShowSidebar(false);
    setMobileShowSidebar(false);
    const allNewsStories = newsStories;
    const filteredData = allNewsStories.filter(function (item) {
      //Applying filter for all the article details in search bar
      const itemData = item.ArticleAuthor.concat(item.ArticleTitle)
        .concat(item.ArticleStart)
        .concat(item.ArticleContent)
        .concat(item.ArticleCategory)
        .toUpperCase();
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    });

    setSearch(text);
    text == ""
      ? setSearchArticleData(newsStories)
      : setSearchArticleData(filteredData);
  };

  //Clicking a source
  const clickedSource = (source) => {
    setSearch(source),
      updateSearch(source),
      saveSearches(source),
      flatListRef.current.scrollToIndex({ index: 0 });
  };

  //-------------------------------------------//
  //             Viewed Articles               //
  //-------------------------------------------//

  //Delete read history
  const clearRecentRead = () => {
    dispatch(reduxRead([]));
    setTriggerReadArticles(!triggerReadArticles);
  };

  //Save the read articles when user visits source site + open site
  const saveRead = (title, link) => {
    WebBrowser.openBrowserAsync(link);
    const savedRead =
      currentReadArticles?.length > 0 ? currentReadArticles : [];
    savedRead.unshift(title);
    const removeDupRead = [...new Set(savedRead)];
    dispatch(reduxRead(removeDupRead.slice(0, 3)));
    setTriggerReadArticles(!triggerReadArticles);
  };

  //pass a function to allow each news story to navigate to the full article
  const goTo = (page, site, source) => {
    navigation.navigate(page, { url: site, author: source });
  };

  //-------------------------------------------//
  //                 Refresh                   //
  //-------------------------------------------//

  //This ref is used to scroll to top when refresh is pressed
  const flatListRef = useRef();

  //fetch the data
  useEffect(() => {
    const fetchData = async () => {
      setFetchingStories(true);
      const pullData = query(
        collection(db, "Articles"),
        orderBy("DateTime"),
        startAfter(lastVisibleData != "" ? lastVisibleData : null), //if data had been fetched before, grab the next batch
        limit(7),
      );
      const documentSnapshots = await getDocs(pullData);

      //Save the last batch as a starting point for the next fetch
      const lastVisible =
        documentSnapshots.docs[documentSnapshots.docs.length - 1];
      setLastVisibleData(lastVisible);

      const allArticles = [];
      documentSnapshots.forEach((snapshot) => {
        let data = snapshot.data();

        allArticles.unshift({
          ArticleCategory: data.ArticleCategory,
          ArticleImage: {
            uri: data.ArticleImage,
          },
          ArticleAuthorIcon: {
            uri: data.ArticleAuthorIcon,
          },
          ArticleAuthor: data.ArticleAuthor,
          ArticleTitle: data.ArticleTitle,
          ArticleStart: data.ArticleStart,
          ArticleContent: data.ArticleContent,
          ArticleLink: data.ArticleLink,
          ArticleDate: data.DateTime,
        });
      });
      const anyCurrentStories = newsStories.concat(allArticles);
      selectedStoryAuthor == "" &&
        setSelectedStoryAuthor(allArticles[0].ArticleAuthor);
      selectedStoryTitle == "" &&
        setSelectedStoryTitle(allArticles[0].ArticleTitle);
      selectedStoryAuthorIcon == "" &&
        setSelectedStoryAuthorIcon(allArticles[0].ArticleAuthorIcon);
      selectedStoryArticleCategory == "" &&
        setSelectedStoryArticleCategory(allArticles[0].ArticleCategory);
      selectedStoryImage == "" &&
        setSelectedStoryImage(allArticles[0].ArticleImage);
      selectedStoryArticleStart == "" &&
        setSelectedStoryArticleStart(allArticles[0].ArticleStart);
      selectedStoryArticleContent == "" &&
        setSelectedStoryArticleContent(allArticles[0].ArticleContent);
      selectedStoryArticleLink == "" &&
        setSelectedStoryArticleLink(allArticles[0].ArticleLink);
      setNewsStories(anyCurrentStories);
      setFetchingStories(false);
    };
    fetchData();
  }, [scrollRefresh]);

  //Filter the news stories based on the categories
  useEffect(() => {
    const setCatgories = async () => {
      const categories = await currentCategoriesSelection;

      //Make a blank list (to catch the category-filtered articles)
      const allNewsDataList = [];

      //Create a copy of the news data (to not edit the new data directly)
      const allNewsData = newsStories;

      //Check if each news article's category is included in the selected categories
      //...If so, push to our list
      for (var i = 0; i < newsStories?.length; i++) {
        categories?.includes(allNewsData[i].ArticleCategory) &&
          allNewsDataList.push(allNewsData[i]);
      }
      //If no categories are selected, return all news stories

      categories?.length > 0
        ? setFilteredNewsData(allNewsDataList)
        : setFilteredNewsData(allNewsData);
    };
    setCatgories();
  }, [currentCategoriesSelection, newsStories]);

  //Create infinite scroll
  const infiniteScroll = () => {
    setScrollRefresh(!scrollRefresh);
  };

  //-------------------------------------------//
  //        Render Items (for Flatlists)       //
  //-------------------------------------------//

  //This renders each of the search history items
  const renderItemSearchHistory = ({ index }) => {
    return <SearchHistoryItem item={index} clickedSearch={clickedSource} />;
  };
  //This renders each of the search history items
  const renderItemReadArticles = ({ index }) => {
    return <ReadArticleItem item={index} clickedSearch={clickedSource} />;
  };

  //This renders each of the sources in the "Sources" section
  const renderItemSources = ({ item }) => {
    return (
      <SearchSourceItem
        item={item}
        clickedSource={clickedSource}
        setPressedSources={setPressedSources}
      />
    );
  };

  //This renders the News items
  const renderItemSavedStories = ({ item }) => {
    return (
      <NewsItems
        updateSearch={updateSearch}
        goTo={goTo}
        item={item}
        selectedStoryTitle={selectedStoryTitle}
        selectedStoryAuthor={selectedStoryAuthor}
        setSelectedStoryAuthor={setSelectedStoryAuthor}
        setSelectedStoryAuthorIcon={setSelectedStoryAuthorIcon}
        setSelectedStoryArticleCategory={setSelectedStoryArticleCategory}
        setSelectedStoryTitle={setSelectedStoryTitle}
        setSelectedStoryImage={setSelectedStoryImage}
        setSelectedStoryArticleStart={setSelectedStoryArticleStart}
        setSelectedStoryArticleContent={setSelectedStoryArticleContent}
        setSelectedStoryArticleLink={setSelectedStoryArticleLink}
        bookmarked={bookmarked}
        pressBookmark={pressBookmark}
      />
    );
  };

  //This renders the News items (mobile)
  const renderItemStoriesMobile = ({ item }) => {
    return (
      <MobileNewsItems
        updateSearch={updateSearch}
        goTo={goTo}
        item={item}
        selectedStoryTitle={selectedStoryTitle}
        selectedStoryAuthor={selectedStoryAuthor}
        bookmarked={bookmarked}
        pressBookmark={pressBookmark}
        saveRead={saveRead}
      />
    );
  };

  //This renders the list for category selection
  const renderItemCategories = ({ item }) => {
    return <CategoriesItem item={item} />;
  };

  //-------------------------------------------//
  //             Create Components             //
  //-------------------------------------------//

  //Bolds the first word (ArticleStart) of the article content
  const ArticleText = (props) => {
    const text = props.text.split(" ");
    return (
      <Text style={styles.articleText}>
        {text.map((text) => {
          if (text == props.ArticleStart) {
            return <Text style={styles.articleFirstWord}>{text}</Text>;
          }
          return `${text} `;
        })}
      </Text>
    );
  };

  //Create the top title that goes before the news stories in the articles list
  const topTitle = () => {
    return search.length > 0 ? (
      <View style={styles.topTitleContainer}>
        <TouchableOpacity
          onPress={() => (updateSearch(""), setShowBookmarks(false))}
        >
          <Feather
            name="x"
            size={25}
            color={"black"}
            style={styles.clearSearch}
          />
        </TouchableOpacity>
        <Animated.Text
          numberOfLines={1}
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Results: {search}
        </Animated.Text>
      </View>
    ) : showBookmarks && currentBookmarks?.length > 0 ? (
      <View style={styles.topTitleContainer}>
        <TouchableOpacity
          onPress={() => (updateSearch(""), setShowBookmarks(false))}
        >
          <Feather
            name="x"
            size={25}
            color={"black"}
            style={styles.clearSearch}
          />
        </TouchableOpacity>
        <Animated.Text
          numberOfLines={1}
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Bookmarked Stories
        </Animated.Text>
      </View>
    ) : Math.abs(currentCategoriesSelection?.length - CategoriesData.length) ==
      CategoriesData.length ? (
      <View style={styles.topTitleContainer}>
        <Animated.Text
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Top Stories
        </Animated.Text>
      </View>
    ) : Math.abs(currentCategoriesSelection?.length - CategoriesData.length) ==
      0 ? (
      <View style={styles.topTitleContainer}>
        <Animated.Text
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Top Stories
        </Animated.Text>
      </View>
    ) : isNaN(
        Math.abs(currentCategoriesSelection?.length - CategoriesData.length),
      ) ? (
      <View style={styles.topTitleContainer}>
        <Animated.Text
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Top Stories
        </Animated.Text>
      </View>
    ) : (
      <View style={styles.topTitleContainer}>
        <Animated.Text
          style={[
            { transform: [{ scale }], opacity: opacity },
            styles.topTitle,
          ]}
        >
          Top Stories
        </Animated.Text>
        <TouchableOpacity onPress={() => setPressedCategories(true)}>
          <Animated.Text
            style={[
              { transform: [{ scale }], opacity: opacity },
              styles.subTitle,
            ]}
          >
            (categories filtered)
          </Animated.Text>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <View style={[styles.browserPromoScreen, { minHeight: height }]}>
      <View style={styles.browserPromoBackdrop}>
        {SearchSourceData.map((item) => (
          <View
            key={item.ArticleAuthor}
            style={[
              styles.browserSourceTile,
              {
                width: browserSourceTileWidth,
                height: browserSourceTileHeight,
              },
            ]}
          >
            <Image
              blurRadius={5}
              resizeMode="contain"
              source={item.SourceImage}
              style={styles.browserSourceTileImage}
            />
          </View>
        ))}
      </View>
      <View style={styles.browserPromoScrim} />
      <View style={styles.browserPromoPanel}>
        <Image
          source={require("../assets/NewsVues Full Logo White.png")}
          style={styles.browserPromoLogo}
        />
        <Text style={styles.browserPromoText}>
          Thank you for being part of the NewsVues journey. We are proud of the
          work we’ve done to bridge technology and news media. As we head into
          our next chapter, we thank you for being a part of our story.
        </Text>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  topTitleContainer: { flexDirection: "row", alignItems: "center" },
  topTitle: {
    paddingLeft: 15,
    paddingVertical: 15,
    paddingRight: 5,
    fontFamily: "Inter_800ExtraBold",
    fontSize: 23,
  },
  articleText: {
    fontSize: 17,
    fontFamily: "Inter_400Regular",
    paddingTop: "7%",
    width: "100%",
    lineHeight: 21,
    color: "black",
  },
  articleFirstWord: { fontFamily: "Inter_700Bold", fontSize: 17 },
  clearSearch: { marginLeft: 10, marginRight: -5 },
  subTitle: {
    paddingVertical: 15,
    fontFamily: "Inter_500Medium",
    fontSize: 15,
    color: colors.greyDark,
  },
  container: { height: "100%", width: "100%" },
  header: {
    paddingLeft: 15,
    fontFamily: "Inter_800ExtraBold",
    fontSize: 35,
  },
  browserPromoScreen: {
    width: "100%",
    paddingHorizontal: 40,
    paddingVertical: 48,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#020617",
    overflow: "hidden",
  },
  browserPromoBackdrop: {
    ...StyleSheet.absoluteFillObject,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    paddingHorizontal: 28,
    paddingVertical: 28,
    opacity: 0.5,
  },
  browserSourceTile: {
    margin: 10,
    borderRadius: 24,
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.08)",
  },
  browserSourceTileImage: {
    width: "82%",
    height: "82%",
    opacity: 0.98,
  },
  browserPromoScrim: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(2, 6, 23, 0.74)",
  },
  browserPromoPanel: {
    width: "100%",
    maxWidth: 760,
    paddingHorizontal: 48,
    paddingVertical: 42,
    borderRadius: 30,
    alignItems: "center",
    // backgroundColor: "rgba(15, 23, 42, 0.58)",
    borderWidth: 0,
    borderColor: "rgba(255,255,255,0.14)",
    zIndex: 2,
  },
  browserPromoLogo: {
    width: 220,
    height: 44,
    marginBottom: 28,
  },
  browserPromoText: {
    width: "100%",
    maxWidth: 620,
    color: "#fff",
    fontSize: 20,
    lineHeight: 32,
    textAlign: "center",
    fontFamily: "Inter_500Medium",
  },
  overlayStyle: {
    backgroundColor: "rgba(0,0,0,.5)",
    zIndex: 100,
    padding: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  mobileOverlayStyle: {
    backgroundColor: "rgba(0,0,0,.5)",
    zIndex: 100,
    justifyContent: "center",
    alignItems: "center",
  },
});
